import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Structure/Header';
import Footer from '../../components/Structure/Footer';
import MainContent from '../../components/Structure/Content/Main';
import Sidebar from '../../components/Structure/Sidebar';
import { setCurrentStep } from '../../store/application/actions';
import { STEP_SUCCESS } from '../../helpers/steps';
import StringHelper from '../../helpers/string-helper';
import UrlHelper from '../../helpers/url-helper';
import checkout from '../../images/checkout.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ToasterHelper from '../../helpers/toaster-helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const SuccessPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const property = useSelector(state => state.property);
  const application = useSelector(state => state.application);
  const { finished, successMessage, pixQrCode, pixPaymentLine } = application;
  const reservation = useSelector(state => state.reservation);
  const { currentStep } = application;
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!finished || StringHelper.isEmpty(successMessage)) {
      history.push(UrlHelper.to(''));
    }
  }, [finished, successMessage, history]);

  if (!finished || StringHelper.isEmpty(successMessage)) {
    return null;
  }

  if (!loaded) {
    setLoaded(true);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (currentStep !== STEP_SUCCESS) {
      dispatch(setCurrentStep(STEP_SUCCESS, false));
    }
  });

  const handleNewReservationButtonClick = () => {
    history.push(UrlHelper.to(''));
  }

  const sidebar = (
    <Sidebar property={property} reservation={reservation} showAbout />
  );

  // const pixText = '00020101021226770014BR.GOV.BCB.PIX2555api.itau/pix/qr/v2/3b3592d9-f5d3-419a-8f8f-f6b903f391345204000053039865802BR5925ZOOP TECNOLOGIA E MEIOS D6009SAO PAULO62070503***63045751';
  // const pixQrCode = 'data:image/png;base64,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';
  
  return (
    <Fragment>
      <Header />

      <MainContent sidebar={sidebar}>
        <Fragment>
          <div className="card mt-n4 mb-4 checkout">
            <div className="card-body">
              <div className="row mt-3">
                <div className="col-12 text-center">
                  <h1 className="text-uppercase" style={{ lineHeight: '22px' }}>
                    {t('titles.successReservation')}
                  </h1>
                  <p className="h6 text-center mt-4 mb-4" style={{ fontSize: '18px' }}>
                    {successMessage}
                  </p>
                  <p className='h6' style={{ fontSize: '18px' }} >
                    {t('titles.thanks', { hostel: property.name })}
                  </p>
                </div>
              </div>
              {!StringHelper.isEmpty(pixQrCode) ?
              <div className="row d-flex flex-column align-items-center">
                <div className='mt-5'>
                  {t('payment.pixMessageScan')}
                </div>
                <div>
                  <img width="250" src={pixQrCode} alt="QR Code" />
                </div>
                <div className='mt-5'>
                  {t('payment.pixMessageCopy')}
                </div>
                <div className='mt-2'>
                  <input 
                    type="text" 
                    readOnly="readOnly" 
                    style={{width: '320px', backgroundColor: '#A0ABC0', border: '0'}} 
                    value={pixPaymentLine} />
                  <OverlayTrigger
                    placement={'top'}
                    overlay={<Tooltip id={`pixCode`}>{t('payment.pixKey')}</Tooltip>}
                  >
                    <FontAwesomeIcon className="ml-2" size='1x' icon={faCopy} style={{cursor: 'pointer'}} onClick={() => {
                      navigator.clipboard.writeText(pixPaymentLine); 
                      ToasterHelper.success(t('payment.pixMessageCopySuccess'));
                      }
                    } />
                  </OverlayTrigger>
                </div>
              </div>
              :
              <div>
                <div className="row">
                  <div className="col-12 text-center mb-5 mt-2">
                    <button className="btn btn-link text-lowercase first-capital-letter h6 text-secondary mb-4 mt-4" style={{ fontSize: '18px' }} onClick={handleNewReservationButtonClick}>
                      {t('titles.makeANewReservation')} <FontAwesomeIcon className="ml-2" icon={faHouse} />
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-8 col-sm-10 col-xs-12 mx-auto">
                    <img src={checkout} alt="" className="img-fluid mb-5" id="checkout_success" />
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </Fragment>
      </MainContent>

      <Footer />
    </Fragment>
  );
};

export default SuccessPage;
